/**
 * Load Google Ads functions
 * */

(function (pmw, undefined) {


	pmw.getGoogleAdsConversionIdentifiersWithLabel = () => {

		let conversionIdentifiers = []

		if (pmwDataLayer?.pixels?.google?.ads?.conversion_ids) {
			Object.entries(pmwDataLayer.pixels.google.ads.conversion_ids).forEach(([key, item]) => {
				if (item) {
					// Check if item is an array (multiple labels for the same conversion_id)
					if (Array.isArray(item)) {
						item.forEach((label) => {
							if (label) {
								conversionIdentifiers.push(key + "/" + label)
							}
						})
					} else {
						conversionIdentifiers.push(key + "/" + item)
					}
				}
			})
		}

		return conversionIdentifiers
	}

	pmw.getGoogleAdsConversionIdentifiers =  () => {

		let conversionIdentifiers = []

		Object.keys(pmwDataLayer.pixels.google.ads.conversion_ids).forEach((key) => {
			conversionIdentifiers.push(key)
		})

		return conversionIdentifiers
	}

	pmw.getGoogleAdsRegularOrderItems = () => {

		let orderItems = []

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			const useVariation = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id
			const productId    = useVariation ? item.variation_id : item.id
			const product      = pmw.getDataLayerProduct(productId)

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("Google Ads: skipped an order item without product data: " + productId)
				return
			}

			orderItems.push({
				quantity                : item.quantity,
				price                   : item.price_tax_excluded,
				google_business_vertical: pmwDataLayer.pixels.google.ads.google_business_vertical,
				id                      : String(product.dyn_r_ids[pmwDataLayer.pixels.google.ads.dynamic_remarketing.id_type]),
			})
		})

		return orderItems
	}

	/**
	 * Send a conversion to a Google Ads conversion action of the shop's own.
	 *
	 * The Google counterpart of pmw.trackCustomFacebookEvent(). A hand-rolled
	 * gtag() call has to reproduce two guards to be correct, and a snippet that
	 * skips them either leaks a conversion past a withdrawn marketing consent or,
	 * far more often, fires nothing at all: on a shop that defers or delays
	 * JavaScript the data layer is on the page long before gtag.js is injected,
	 * so `if (!window.gtag) return;` is not a race that sometimes works, it is a
	 * guaranteed dead end.
	 *
	 * @param {string} sendTo The conversion identifier, "AW-CONVERSION_ID/CONVERSION_LABEL".
	 * @param {object} data   Optional event parameters (value, currency, transaction_id, ...).
	 *
	 * @returns {Promise|undefined} Resolves once the conversion was sent. Undefined when a
	 *                              guard declined it, so always null-check before chaining.
	 *
	 * @since 1.67.1
	 */
	pmw.trackCustomGoogleAdsConversion = (sendTo, data = {}) => {
		try {

			if (!sendTo) {
				pmw.console.error("Google Ads: trackCustomGoogleAdsConversion needs a conversion identifier like AW-CONVERSION_ID/CONVERSION_LABEL")
				return
			}

			// The same marketing gate every Pixel Manager Google Ads conversion passes.
			if (!pmw.googleConfigConditionsMet({type: "marketing"})) return

			const payload = Object.assign({}, data, {send_to: sendTo})

			return pmw.gtagLoaded().then(() => {
				gtag("event", "conversion", payload)
				pmw.console.log("Google Ads: custom conversion sent", payload)
			}).catch(() => {
				pmw.console.error("Google Ads: the Google tag never became ready, so the custom conversion " + sendTo + " was not sent")
			})

		} catch (e) {
			console.error(e)
		}
	}

}(window.pmw = window.pmw || {}))
